<template>
    <div class="mobile-navigation">
        <div class="mobile-navigation__inner" v-show="isNavigationInitialized">
<!--            <ul class="breadcrumb d-block px-3 py-0">-->
<!--                <li class="btn-close" @click="closeNavigation()"></li>-->

<!--                <li class="breadcrumb-item" @click="slideTo(null, true)">-->
<!--                    <i class="fa fa-home" aria-hidden="true"></i>-->
<!--                </li>-->

<!--                <li class="breadcrumb-item" v-for="breadcrumb in breadcrumbs" @click="slideTo(breadcrumb.parent, true)">-->
<!--                    {{ breadcrumb.name }}-->
<!--                </li>-->
<!--            </ul>-->

            <div id="accordion">
                <div class="card card--main">
                    <div class="navigation-accordion__headline" :class="{'active': isHome }">
                        <a class="navigation-accordion__headline" href="/">
                            {{ $translate('FLGNTLT::Template.HompageCategoryName')}}
                        </a>
                    </div>
                </div>

                <template v-for="(category, key) in navigationTree">
                    <div class="card" :class="'card--'+ key">
                        <div v-if="category.details.length > 0" class="navigation-accordion__headline" :id="'heading'+ key" :class="{'active': openCategories.includes(category.id) }">
                            <a v-if="category.childCount > 0" class="navigation-accordion__headline" data-toggle="collapse" :href="'#collapse'+ key" role="button"  aria-expanded="true" :aria-controls="'collapse'+ key">
                                {{category.details[0].name}}
                            </a>
                            <a v-else-if="category.details.length > 0" class="navigation-accordion__headline" :href="getCategoryUrl(category.details[0])">
                                {{category.details[0].name}}
                            </a>
                        </div>

                        <div v-if="category.childCount > 0" :id="'collapse'+ key" class="collapse" :aria-labelledby="'heading'+ key" data-parent="#accordion">
                            <ul class="navigation-accordion__ul">
                                <li class="navigation-accordion__li" v-if="hasAll.includes(category.id + '') && category.details.length > 0" :class="{'active': openCategories.includes(category.id) && openCategories.length === 1}">
									<a :href="getCategoryUrl(category.details[0])">{{ $translate('FLGNTLT::Template.all') }}</a>
								</li>
                                <template v-if="hasArchive.includes(category.id + '')">
                                    <template  v-for="(subCat, key2) in reverseArray(category.children)">
                                        <li v-if="key2 < 5 && subCat.details.length > 0  && category.details.length > 0" class="navigation-accordion__li" :class="{'active': openCategories.includes(subCat.id)}">
											<a :href="getCategoryUrl(category.details[0], subCat.details[0])">{{ subCat.details[0].name }}</a>
										</li>
                                    </template>
                                </template>
                                <template v-else>
                                    <template v-for="subCat in category.children">
                                        <li v-if="subCat.details.length > 0 && category.details.length > 0" class="navigation-accordion__li" :class="{'active': openCategories.includes(subCat.id)}">
											<a :href="getCategoryUrl(category.details[0], subCat.details[0])">{{ subCat.details[0].name }}</a>
										</li>
                                    </template>
                                </template>
                                <li class="navigation-accordion__li" v-if="hasArchive.includes(category.id + '')  && category.details.length > 0" :class="{'active': openCategories.includes(category.id) && openCategories.length === 1}">
									<a :href="getCategoryUrl(category.details[0])">{{ $translate('FLGNTLT::Template.archive') }}</a>
								</li>
                            </ul>
                        </div>
                    </div>
                </template>
            </div>
        </div>

        <slot name="languageselect"></slot>

        <template v-if="!isNavigationInitialized">
            <ul class="breadcrumb">
                <li class="btn-close" @click="closeNavigation()"></li>

                <li class="breadcrumb-item">
                    <i class="fa fa-home" aria-hidden="true"></i>
                </li>
            </ul>

            <loading-animation></loading-animation>
        </template>
    </div>
</template>

<script>
import { MediaQueryHelper } from "ceres/app/helper/MediaQueryHelper";
import { isNullOrUndefined, isDefined } from "ceres/app/helper/utils";
import Vue from "vue";
import { mapState } from "vuex";

export default {

    props: {
        template: {
            default: "#vue-mobile-navigation",
            type: String
        },
        initialCategory: Object,
        breakpoints: {
            type: Array,
            default: () => ["xs", "sm", "md"]
        },
        includeLanguage: Boolean,
        hasArchive: Array,
        hasAll: Array,

    },

    data()
    {
        return {
            openCategories: [],
            dataContainer1: {
                parent: {},
                categories: []
            },
            dataContainer2: {
                parent: {},
                categories: []
            },
            useFirstContainer: false,
            isNavigationInitialized: false,
            selectedCategory: null,
            isHome: false
        };
    },

    computed:
    {
        breadcrumbs()
        {
            const breadcrumbs = [];
            let container = this.useFirstContainer ? this.dataContainer2 : this.dataContainer1;

            while (container && container.parent && Object.keys(container.parent).length)
            {
                breadcrumbs.unshift(
                    {
                        name: container.parent.details[0].name,
                        parent: container.parent || null
                    });

                container = container.parent;
            }

            return breadcrumbs;
        },

        ...mapState({
            navigationTree: state => state.navigation.tree
        }),

    },

    created()
    {
        this.$store.commit("setCurrentCategory", this.initialCategory);
    },

    mounted()
    {
        this.addEventListener();
        this.isHome = window.location.pathname === "/";
    },

    methods:
    {
        reverseArray(input) {
            let ret = [];
            for(let i = input.length-1; i >= 0; i--) {
                ret.push(input[i]);
            }
            return ret;
        },
        setCatActive(activeCategory){
            if(this.initialCategory.id === subCat){
                if(typeof activeCategory.parent !== 'undefined'){
                    // console.log("!undefined: " + activeCategory.id +" | " + activeCategory.parent.id);
                    return [activeCategory.id, activeCategory.parent.id]
                }

                else{
                    // console.log("!undefined: " + activeCategory.id);
                    return [activeCategory.id, activeCategory.id]
                }
            }

            else {
                // console.log("else");
                return ['','']
            }
        },

        addEventListener()
        {
            const QueryHelper = new MediaQueryHelper();
            const breakpoint = QueryHelper.getCurrentBreakpoint();

            QueryHelper.addFunction(this.loadInitialTree, this.breakpoints);

            if (this.breakpoints.includes(breakpoint))
            {
                this.loadInitialTree();
            }
        },

        loadInitialTree()
        {
            if (this.navigationTree.length <= 0)
            {
                const categoryId = this.initialCategory && this.initialCategory.id ? this.initialCategory.id : null;

                this.$store.dispatch("loadPartialNavigationTree", categoryId)
                    .then(response =>
                    {
                        this.$store.commit("setNavigationTree", response);
                        this.initNavigation();
                    });
            }
        },

        initNavigation()
        {
            if (this.initialCategory && this.initialCategory.id)
            {
                if (this.initialCategory.linklist === "N")
                {
                    this.$store.commit("setCurrentCategory", this.initialCategory);
                }
                else
                {
                    this.$store.dispatch("setCurrentCategoryById", { categoryId: parseInt(this.initialCategory.id) });
                    this.initialSlide(this.$store.state.navigation.currentCategory);
                }
            }

            this.dataContainer1.parent = null;
            this.dataContainer1.categories = this.navigationTree;
            this.isNavigationInitialized = true;

            if(this.$store.state.navigation.currentCategory != null){
                this.openCategories.push(this.$store.state.navigation.currentCategory.id);
                // this.openCategories.push(this.$store.state.navigation.currentCategory.parentCategoryId);

                if(this.$store.state.navigation.currentCategory.parent != null){
                    this.openCategories.push(this.$store.state.navigation.currentCategory.parent.id);
                }
            }
        },

        initialSlide(currentCategory)
        {
            if (currentCategory)
            {
                if (currentCategory.children)
                {
                    this.slideTo(currentCategory);
                }
                else if (currentCategory.parent)
                {
                    this.slideTo(currentCategory.parent);
                }
            }
        },

        slideTo(category, back)
        {
            const children = isDefined(category) ? category.children : this.navigationTree;
            const categoryId = isDefined(category) ? category.id : null;

            this.loadPartialTree(categoryId);
            this.selectedCategory = category;

            if (this.useFirstContainer)
            {
                this.dataContainer1.parent = category;
                this.dataContainer1.categories = children || [];

                $("#menu-2").trigger("menu-deactivated", { back: !!back });
                $("#menu-1").trigger("menu-activated", { back: !!back });
            }
            else
            {
                this.dataContainer2.parent = category;
                this.dataContainer2.categories = children || [];

                $("#menu-1").trigger("menu-deactivated", { back: !!back });
                $("#menu-2").trigger("menu-activated", { back: !!back });
            }

            this.useFirstContainer = !this.useFirstContainer;
        },

        loadPartialTree(categoryId)
        {
            // eslint-disable-next-line eqeqeq
            if (this.selectedCategory != categoryId ||
                (isDefined(this.selectedCategory) && this.selectedCategory.id !== categoryId))
            {
                this.$store.dispatch("loadPartialNavigationTree", categoryId)
                    .then(response =>
                    {
                        if ((isNullOrUndefined(this.selectedCategory) && isNullOrUndefined(categoryId)) ||
                            (isDefined(this.selectedCategory) && this.selectedCategory.id === categoryId))
                        {
                            this.$store.commit("setNavigationTree", response);
                            this.updateDataContainers(categoryId);
                        }
                    });
            }
        },

        updateDataContainers(categoryId)
        {
            const containers = ["dataContainer1", "dataContainer2"];
            const category = this.getCategoryById(categoryId, this.navigationTree);

            for (const container of containers)
            {
                if (category)
                {
                    this[container].parent = category;
                    this[container].categories = category.children;
                }
                else
                {
                    // root level
                    this[container].parent = null;
                    this[container].categories = this.navigationTree;
                }
            }
        },

        getCategoryById(categoryId, tree)
        {
            for (const cat of tree)
            {
                if (categoryId === cat.id)
                {
                    return cat;
                }
                else if (cat.children)
                {
                    const foundCat = this.getCategoryById(categoryId, cat.children);

                    if (foundCat)
                    {
                        return foundCat;
                    }
                }
            }

            return null;
        },

        closeNavigation()
        {
            document.querySelector(".mobile-navigation").classList.remove("open");
            document.querySelector("body").classList.remove("menu-is-visible");
        },

        getCategoryUrl(details, subDetails)
        {
			const url = details.nameUrl;

            const trailingSlash = url[0] === "/" ? "" : "/";
            const prefix = this.includeLanguage ? `/${App.language}${trailingSlash}` : "";

			if(isNullOrUndefined(subDetails)){
				return prefix + url;
			}

			return prefix + url + '/' + subDetails.nameUrl
        }
    },

    directives:
    {
        menu: {
            bind(el)
            {
                // add "activated" classes when menu is activated
                $(el).on("menu-activated", (event, params) =>
                {
                    $(event.target).addClass("menu-active");
                    $(event.target).addClass(params.back ? "animate-in-from-left" : "animate-in-from-right");
                });
                // add "deactivated" classes when menu is deactivated
                $(el).on("menu-deactivated", (event, params) =>
                {
                    $(event.target).removeClass("menu-active");
                    $(event.target).addClass(params.back ? "animate-out-to-right" : "animate-out-to-left");
                });
                // this removes the animation class automatically after the animation has completed
                $(el).on("animationend webkitAnimationEnd oAnimationEnd MSAnimationEnd", () =>
                {
                    $(".mainmenu").removeClass((index, className) =>
                    {
                        return (className.match(/(^|\s)animate-\S+/g) || []).join(" ");
                    });
                });
            }
        }
    }
}
</script>
